import { Checkbox } from '@/components/ui/checkbox';
import { InvoiceReviewPreviewPane } from './invoice-review-preview-pane';

export interface InvoiceReviewPreviewColumnProps {
  readonly previewUrl: string | null;
  readonly isPreviewing: boolean;
  // A non-final sell row can render its predecessor history; the toggle is shown
  // only when that choice is available (and re-renders the preview on change).
  readonly historyEligible: boolean;
  readonly includeChainHistory: boolean;
  readonly onToggleChainHistory: (next: boolean) => void;
}

// The dialog's right pane: the optional chain-history toggle above the live PDF
// preview.
export function InvoiceReviewPreviewColumn(props: Readonly<InvoiceReviewPreviewColumnProps>) {
  return (
    <div className="flex min-h-0 flex-col gap-3 lg:w-[26rem] lg:border-l lg:pl-4">
      {props.historyEligible ? (
        <label className="flex items-start gap-2 text-sm" htmlFor="chain-history-toggle">
          <Checkbox
            id="chain-history-toggle"
            data-testid="invoice-review-chain-history"
            checked={props.includeChainHistory}
            disabled={props.isPreviewing}
            onCheckedChange={(v) => {
              props.onToggleChainHistory(v === true);
            }}
          />
          <span>
            Include chain history
            <span className="text-muted-foreground block text-xs">
              Show the running history of this row&rsquo;s predecessors, not just its own value.
            </span>
          </span>
        </label>
      ) : null}
      <InvoiceReviewPreviewPane previewUrl={props.previewUrl} isPreviewing={props.isPreviewing} />
    </div>
  );
}
